module.exports = __webpack_public_path__ + "01_long_grey.0649383a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_long_grey.png
// module id = Hllj
// module chunks = 0